import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';

import { useDialog, useRequestState } from '@app/hooks';
import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
  DeleteDialog,
} from '@app/components';
import { Strings } from '@app/constants';
import { AddPortfolio } from './add-portfolio';
import { IPortfolio } from '../types';
import { deletePortfolio } from '../slice';
import { selectDeletePortfolioState } from '../selector';

interface Props {
  row: IPortfolio;
}

const RowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const deleteDialog = useDialog();
  const editDialog = useDialog();

  const dispatch = useDispatch();

  const actions = [
    { label: Strings.rowActions.edit, callback: editDialog.show },
    { label: Strings.rowActions.delete, callback: deleteDialog.show },
  ];

  const { loading } = useRequestState({
    stateSelector: selectDeletePortfolioState,
    onSuccess: deleteDialog.hide,
    successMessageShown: true,
    errorShown: true,
  });

  const onPressDelete = () => {
    dispatch(
      deletePortfolio({
        id: row?.id,
      })
    );
  };

  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      <DeleteDialog
        title={`${Strings.common.delete} ${Strings.portfolio.portfolio}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.deleteCaption(Strings.portfolio.portfolio)}
        loading={loading}
        visible={deleteDialog.visible}
        onClickDelete={onPressDelete}
        onClose={deleteDialog.hide}
      />

      {editDialog.visible && <AddPortfolio open onClose={editDialog.hide} row={row} />}
    </>
  );
};

export { RowActions };
